<template>
    <div class="user_info">
        <a-popover placement="topLeft" overlayClassName="header_dropdown" v-if="$i18n.locale==='zh_CN'">
            <template slot="content">
                <ul class="header_dropdown_menu tool_dropdown_menu">
                    <li><a href="https://afire.leihuo.netease.com/" target="_blank"><span class="tool_icon ad_icon"></span>雷火广告平台</a></li>
                    <li><a href="https://ux.leihuo.netease.com/tool/book/" target="_blank"><span class="tool_icon book_icon"></span>雷火UX预约服务系统</a></li>
                    <li><a href="https://ux.leihuo.netease.com/recsys/" target="_blank"><span class="tool_icon recsys_icon"></span>雷火推荐系统</a></li>
                    <li><a href="https://ux.leihuo.netease.com/playerbi/" target="_blank"><span class="tool_icon book_icon"></span>雷火UX天眼自主取数系统</a></li>
                    <li><a href="https://ux.leihuo.netease.com/uxdoc/" target="_blank"><span class="tool_icon book_icon"></span>雷火UX知识分享平台</a></li>
                    <li><a href="https://ux.leihuo.netease.com/class/" target="_blank"><span class="tool_icon book_icon"></span>雷火学堂</a></li>
                    <li><a href="https://ux.leihuo.netease.com/playerdb/" target="_blank"><span class="tool_icon book_icon"></span>雷火玩家信息库</a></li>
                    <li><a href="http://42.186.130.23:8080/unogm/#/" target="_blank"><span class="tool_icon book_icon"></span>GM邮件推送系统</a></li>
                    <li><a href="tool.html#/aduser" target="_blank"><span class="tool_icon book_icon"></span>安卓用户特征</a></li>
                    <li><a href="tool.html#/apprank" target="_blank"><span class="tool_icon book_icon"></span>游戏应用排行</a></li>
                    <li><a href="tool.html#/path" target="_blank"><span class="tool_icon book_icon"></span>玩家路径图</a></li>
                    <li><a href="http://ux-web-vm.cloud.leihuo.netease.com/pmt2/" target="_blank"><span class="tool_icon book_icon"></span>QA流程管理平台</a></li>
                    <li><a href="tool.html#/alarm" target="_blank"><span class="tool_icon book_icon"></span>游戏新外放内容提醒系统</a></li>
                </ul>
            </template>
            <a class="header_dropdown_link tool_menu_link" href="#">{{$t('ux.uxtools')}}</a>
        </a-popover>
        <a-popover placement="topLeft" overlayClassName="header_dropdown">
            <template slot="content">
                <ul class="header_dropdown_menu">
                    <li><a href="javascript:;" @click="$service.logout()"><a-icon type="logout" />{{ $t('common.logout') }}</a></li>
                    <li v-if="$i18n.locale==='zh_CN'"><a href="index.html#/auth" target="_blank"><a-icon type="unlock" /> 权限申请</a></li>
                    <li v-if="$i18n.locale==='zh_CN' && (user.admin || info.config)"><a :href="$service.PROJ_CODE?`manage.html?proj=${$service.PROJ_CODE}`:'manage.html'" target="_blank" class="manage_link"><a-icon type="setting" /> 后台管理</a></li>
                    <li v-if="$i18n.locale==='zh_CN' && $service.PROJ_CODE && (user.admin || info.dim)"><a :href="`game.html?proj=${$service.PROJ_CODE}#/dim`" target="_blank" class="manage_link"><a-icon type="database" /> 配置管理</a></li>
                </ul>
            </template>
            <a class="header_dropdown_link user_info_link" href="#">Hi, {{user?user.name:''}} <a-icon type="down" /></a>
        </a-popover>
        
        <div class="header_language" v-if="['demo', 'l26', 'l26na'].includes($service.PROJ_CODE)">
            <span :class="{selected: this.$i18n.locale==='en_US'}" @click="()=>changeLang('en_US')">EN</span>
            <span :class="{selected: this.$i18n.locale==='zh_CN'}" @click="()=>changeLang('zh_CN')">中文</span>
        </div>
    </div>
</template>

<script>
import storage from '@/utils/storage'
import { Popover} from 'ant-design-vue';
import Vue from 'vue'
import qs from 'qs'
Vue.use(Popover)

export default {
    methods: {
        changeLang(code) {
            this.$i18n.locale = code
            storage.local.set('lang', code)
            const locationSearch = qs.parse(location.search.length>0?location.search.substring(1):"")
            const params = {...locationSearch, 'lang':code}
            location.href = `${location.pathname}?${Object.keys(params).map(key=>`${key}=${params[key]}`).join(`&`)}${location.hash}`
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        info() {
            return this.$store.state.game.info
        },
    }
}
</script>

<style lang="less">
.header_language {
    display: inline-block;
    margin: 4px 0px 0 20px;
    float: left;
    span {    
        display: inline-block;
        background: #2f3548;
        width: 35px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &.selected {
            background: #607ad1;
        }
        &:nth-child(1) {
            border-radius: 5px 0 0 5px;
        }
        &:nth-last-child(1) {
            border-radius: 0 5px 5px 0;
        }
    }
}
</style>